import { createSlice } from '@reduxjs/toolkit'

export type TConferenceAlert = {
  meetingId: string
  from?: string
  title: string
  avatar: string
  description: string
  date: string
  url: string
  isPrivate?: boolean
  conferenceType: string
}

export type TConferenceResponse = {
  isAccepted: boolean
  from: string
  meetingId: string
}

interface ConferenceState {
  data: TConferenceAlert[]
  responses: TConferenceResponse[]
  visible: boolean
}

const initialState: ConferenceState = {
  data: [],
  responses: [],
  visible: false,
}

export const { actions: conferenceActions, reducer: ConferenceReduder } = createSlice({
  initialState,
  name: 'conference',
  reducers: {
    fillInitialState(state, action) {
      if (action.payload?.length === 0) return
      state.data = action.payload
      state.visible = true
    },
    showAlerts(state) {
      state.visible = true
    },
    newConference(state, action) {
      state.data = [action.payload, ...state.data]
      state.visible = true
    },
    resolveConference(state, action) {
      state.data.splice(action.payload.index, 1)
      if (state.data.length == 0) state.visible = false
    },
    rejectConference(state, action) {
      const meetingId = action.payload?.meetingId
    
      if (!meetingId) return
    
      state.data = state.data.filter((meet) => meet.meetingId !== meetingId)
      state.visible = state.data.length > 0
    },
    clearAllConference(state) {
      state.data = []
      state.visible = false
    },
    videoCallResponse(state, action) {
      state.responses = [action.payload, ...state.responses]
    },
    removeResponse(state, action) {
      state.responses = state.responses.filter((res) => res.meetingId !== action.payload.meetingId)
    },
  },
})
